import React from 'react';
import { FaLinkedin, FaEnvelope, FaGlobe } from 'react-icons/fa';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-line">Reese Kunz</span>
            </h1>
            <p className="hero-subtitle">
              Content Strategist & Marketing Professional with experience in SEO and data-driven optimization
            </p>
            <p className="hero-location">
              📍 Portland, OR
            </p>

            <div className="hero-links">
              <a
                href="https://linkedin.com/in/reesekunz"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-link"
              >
                <FaLinkedin />
                LinkedIn
              </a>
              <a
                href="mailto:reesejkunz@gmail.com"
                className="hero-link"
              >
                <FaEnvelope />
                Email
              </a>
              <a
                href="https://x.com/reesekunz"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-link"
              >
                <FaGlobe />
                Twitter/X
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;